import type { MapBuilderCalcStatus } from '@core/core/types'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import {
  calculateSurfaceByKrigingAction,
  calculateSurfaceByMAAction,
  calculateSurfaceByMCAction,
  calculateSurfaceByRBFAction,
  calculateSurfaceBySCAction,
} from './surfaceCalcActions'

const surfaceCalcAdapter = createEntityAdapter<string>({
  selectId: entity => entity,
})

const initialValue: { status: MapBuilderCalcStatus } = {
  status: 'ready',
}

const initialState = surfaceCalcAdapter.getInitialState(initialValue)
const surfaceCalcSlice = createSlice({
  name: 'surfaceCalc',
  initialState,
  reducers: {
    clearSurfaceCalc() {
      return initialState
    },
  },
  extraReducers: builder => {
    builder
      .addCase(calculateSurfaceByRBFAction.pending, state => {
        state.status = 'calculating'
      })
      .addCase(calculateSurfaceByRBFAction.fulfilled, state => {
        state.status = 'ready'
      })
      .addCase(calculateSurfaceByRBFAction.rejected, state => {
        state.status = 'failed'
      })
      .addCase(calculateSurfaceByKrigingAction.pending, state => {
        state.status = 'calculating'
      })
      .addCase(calculateSurfaceByKrigingAction.fulfilled, state => {
        state.status = 'ready'
      })
      .addCase(calculateSurfaceByKrigingAction.rejected, state => {
        state.status = 'failed'
      })
      .addCase(calculateSurfaceBySCAction.pending, state => {
        state.status = 'calculating'
      })
      .addCase(calculateSurfaceBySCAction.fulfilled, state => {
        state.status = 'ready'
      })
      .addCase(calculateSurfaceBySCAction.rejected, state => {
        state.status = 'failed'
      })
      .addCase(calculateSurfaceByMCAction.pending, state => {
        state.status = 'calculating'
      })
      .addCase(calculateSurfaceByMCAction.fulfilled, state => {
        state.status = 'ready'
      })
      .addCase(calculateSurfaceByMCAction.rejected, state => {
        state.status = 'failed'
      })
      .addCase(calculateSurfaceByMAAction.pending, state => {
        state.status = 'calculating'
      })
      .addCase(calculateSurfaceByMAAction.fulfilled, state => {
        state.status = 'ready'
      })
      .addCase(calculateSurfaceByMAAction.rejected, state => {
        state.status = 'failed'
      })
  },
})

export default surfaceCalcSlice.reducer
